import CodeForm from './code.form';
import Form from "../../form";
import Model from "../../../model/model";

import { ask } from "../../../utils/popups";
import { pst } from '../../../http/api';
import SetPasswordForm from './set.password.form';





export default Form.extend( {

    template: 'jst/auth.login.form',

    [Form.event( 'password:restore' )]() {
        return passwordReset( this.model.get( 'login' ) )
            .then( login => this.model.set( 'login', login ) )
    }

} );





const EnterLoginForm = Form.extend( {

    template: 'jst/auth.enter.login.form',

    events: {

        'keyup [type=text]'(/* e */) {
            this.$el.closest( '.modal' ).find( '.action-accept' )
                [0]
                .disabled = this.$( '[type=text]' ).val().length < 3;
        },

    },

} );

function passwordReset(login) {
    const enterLoginForm = new EnterLoginForm();
    const binding = enterLoginForm.bind( new Model( { login: login || '' } ) );

    return ask( binding, 
        'auth::label - enter login', 'actions::ready', 'actions::cancel',
        {
            afterRender(_, firstTime) {
                if (firstTime)
                    this.$( '.action-accept' )[0].disabled = !login;
            }
        },
        (/*form*/) => pst( `/auth/password-restore/init?apiVersion=2.0` ).cerebellum()
            .body( { login: enterLoginForm.model.get( 'login' ) } )
            .execute()
            .catch( resp => Form.handleHttpError( enterLoginForm, resp ) ) )

        // ask() done here ^^^

        .then( resp => {
            let { token, next_email_at } = resp;
            return CodeForm.popup( { 
    
                token, 
                next_attempt_at: next_email_at,
        
                send: (code, codeForm) => pst( `/auth/password-restore/confirm-login/${codeForm.options.token}?apiVersion=2.0` ).cerebellum()
                    .body( { code } )
                    .execute()
                    .catch( resp => Form.handleHttpError( codeForm, resp ) ),

                newCode: codeForm => pst( `/auth/password-restore/init?apiVersion=2.0` ).cerebellum()
                    .body( { login: enterLoginForm.model.get( 'login' ) } )
                    .execute()
                    .then( ({ next_email_at, token: newToken }) => {
                        codeForm.options.next_attempt_at = next_email_at;
                        codeForm.options.token = token = newToken;
                    } ),
        
            } ).then( () => token );
        } )
        .then( token => SetPasswordForm.popup( { token } ) )
        .then( () => enterLoginForm.model.get( 'login' ) ); 
}



// WEBPACK FOOTER //
// ./src/js/view/module/auth/login.form.js